import { atom } from 'recoil';
import { TaskOutput } from '~/backend/connector-api/connector-schemas';
import { GenerationModelDetails } from '~/domain/dicom/dicomBase';
import { DoseTargetData } from '~/utils/transforms/doseTargetsTransforms';

export type DosePredictionTaskState = {
    model?: GenerationModelDetails;
    targets?: DoseTargetData[];
    output?: TaskOutput;
    polling?: boolean;
};

export const dosePredictionTaskState = atom<DosePredictionTaskState>({
    key: 'dosePredictionTaskState',
    default: undefined,
});
